@use '../../../../../styles/scss/vcom/mixins/breakpoints';

:host {
  display: block;
}

.vs-marquee-container {
  img {
    pointer-events: none;
  }
  .slides-wrapper-marquee,
  .slides-wrapper-submarquee {
    position: relative;    
    ul {
      // START GENAI@GHCOPILOT
      list-style: none;
      margin: 0;
      padding: 0;
      // END GENAI@GHCOPILOT
    }
  }

  .slide {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 1s;
    z-index: 0;
  }

  .slide.active {
    opacity: 1;
    z-index: 1;
  }
}